module.exports = __webpack_public_path__ + "img/ej-02.1d66fd61.svg";